import DOMPurify from "dompurify";

/**
 * Sanitizes email HTML using a strict tag/attribute allowlist, shared by every
 * surface that shows an email body. The allowlist keeps presentational markup
 * (hr, center, table sizing attributes) — email lays itself out with those
 * rather than with stylesheets, so dropping them collapses the design.
 */
export const sanitizeEmailHtml = (html: string) =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p",
      "br",
      "hr",
      "strong",
      "em",
      "u",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "ul",
      "ol",
      "li",
      "a",
      "img",
      "table",
      "thead",
      "tbody",
      "tr",
      "th",
      "td",
      "div",
      "span",
      "center",
      "blockquote",
      "pre",
      "code"
    ],
    ALLOWED_ATTR: [
      "href",
      "src",
      "alt",
      "title",
      "style",
      "class",
      "target",
      "rel",
      "width",
      "height",
      "align",
      "valign",
      "bgcolor",
      "cellpadding",
      "cellspacing",
      "border"
    ],
    ALLOW_DATA_ATTR: false
  });
